module.exports = __webpack_public_path__ + "img/burgkirchen_raum.faf92b05.jpg";